import { render, staticRenderFns } from "./dataReview.vue?vue&type=template&id=8d5abeca&scoped=true&"
import script from "./dataReview.vue?vue&type=script&lang=js&"
export * from "./dataReview.vue?vue&type=script&lang=js&"
import style0 from "./dataReview.vue?vue&type=style&index=0&id=8d5abeca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d5abeca",
  null
  
)

export default component.exports